import * as yup from 'yup'

declare module 'yup' {
  interface NumberSchema {
    /**
     * @description Transform empty string to undefined so required() validation catches it.
     * This resolves the validation message: "{field} must be a `number` type, but the final value was: `NaN` (cast from the value `""`)."
     * For use with NumberField components where empty strings should be treated as undefined rather than NaN.
     * @returns The schema
     */
    coerceEmptyString(): this
  }
}

// Attach to number schema type only
yup.addMethod(yup.number, 'coerceEmptyString', function () {
  return this.transform((value, originalValue) => {
    // Transform empty string or null to undefined so required() validation catches it.
    // NumberField stores null for cleared fields, but raw HTML inputs may still produce ''.
    return originalValue === '' || originalValue === null ? undefined : value
  })
})

export {}
